import { ref } from 'vue'

// Меньше — раньше. Серверная модалка идёт впереди хардкода DAY-1.
export const QUEUE_PRIORITY = { server: 0, day1: 1 } as const

export interface QueueItem {
  id: string
  priority: number
  open: () => void
}

// Синглтон-шина: на экране одновременно не больше одной модалки из очереди.
const activeId = ref<string | null>(null)
let pending: QueueItem[] = []
let holds = 0

function pump (): void {
  if (activeId.value !== null || holds > 0 || pending.length === 0) return
  pending.sort((a, b) => a.priority - b.priority)
  const next = pending.shift() as QueueItem
  activeId.value = next.id
  next.open()
}

function enqueue (item: QueueItem): void {
  if (activeId.value === item.id || pending.some(p => p.id === item.id)) return
  pending.push(item)
  pump()
}

function release (id: string): void {
  if (activeId.value === id) {
    activeId.value = null
    pump()
    return
  }
  pending = pending.filter(p => p.id !== id)
}

/**
 * Пока удержание не снято, очередь копит заявки и ничего не открывает. Нужна, чтобы
 * DAY-1, вставшая в очередь, пока грузится список правил, не обогнала серверную модалку.
 */
function hold (): () => void {
  holds++
  let released = false
  return () => {
    if (released) return
    released = true
    holds--
    pump()
  }
}

export function resetModalQueue (): void {
  activeId.value = null
  pending = []
  holds = 0
}

export const modalQueue = { activeId, enqueue, release, hold }
